<app-dialog [dialogTitle]="'public.profile.address.addOrUpdateTitle' | translate">
  <app-dialog-content class="content">
      {{ data?.message }}
  </app-dialog-content>
  <app-dialog-actions>
    <app-button [mat-dialog-close]="'createNew'">
      {{ 'public.profile.address.createNew' | translate }}
    </app-button>
    <app-button [mat-dialog-close]="'update'">
      {{ 'public.profile.address.update' | translate }}
    </app-button>
  </app-dialog-actions>
</app-dialog>
